/**
 * Action types for connected clients Graph functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle connected clients graph.
*/

export const CONNECTED_CLIENTS_GRAPH_API_LOADING = 'CONNECTED_CLIENTS_GRAPH_API_LOADING';
export const SAVE_CONNECTED_CLIENTS_GRAPH = 'SAVE_CONNECTED_CLIENTS_GRAPH';

// group connected clients
export const SAVE_GROUP_CONNECTED_CLIENTS_GRAPH = 'SAVE_GROUP_CONNECTED_CLIENTS_GRAPH';
export const GROUP_CONNECTED_CLIENTS_GRAPH_API_LOADING = 'GROUP_CONNECTED_CLIENTS_GRAPH_API_LOADING';

// ap modal and firmware distribution constants
export const AP_MODAL_AND_FIRM_DIST_GRAPH_API_LOADING = 'AP_MODAL_AND_FIRM_DIST_GRAPH_API_LOADING';
export const SAVE_AP_MODAL_AND_FIRM_DIST_GRAPH = 'SAVE_AP_MODAL_AND_FIRM_DIST_GRAPH';

// latching time constants
export const LATCHING_TIME_API_LOADING = 'LATCHING_TIME_API_LOADING';
export const SAVE_LATCHING_TIME_GRAPH = 'SAVE_LATCHING_TIME_GRAPH';

// router aggr stats constants
export const ROUTER_AGGR_STATS_API_LOADING = 'ROUTER_AGGR_STATS_API_LOADING';
export const SAVE_ROUTER_AGGR_STATS_GRAPH = 'SAVE_ROUTER_AGGR_STATS_GRAPH';

// router cpu and  memory utilisation constants
export const ROUTER_CPU_MEMORY_API_LOADING = 'ROUTER_CPU_MEMORY_API_LOADING';
export const SAVE_ROUTER_CPU_MEMORY_GRAPH = 'SAVE_ROUTER_CPU_MEMORY_GRAPH';

// client stats constants
export const CLIENT_STATS_API_LOADING = 'CLIENT_STATS_API_LOADING';
export const SAVE_CLIENT_STATS_GRAPH = 'SAVE_CLIENT_STATS_GRAPH';

// client stats and events constants
export const CLIENT_STATS_AND_EVENTS_API_LOADING = 'CLIENT_STATS_AND_EVENTS_API_LOADING';
export const SAVE_CLIENT_STATS__AND_EVENTS_GRAPH = 'SAVE_CLIENT_STATS__AND_EVENTS_GRAPH';
export const CLIENT_SESSION_AND_AFFINITY_API_LOADING = 'CLIENT_SESSION_AND_AFFINITY_API_LOADING';
export const CLIENT_SESSION_AND_AFFINITY_API_SUCCESS = 'CLIENT_SESSION_AND_AFFINITY_API_SUCCESS';

// aprecom details constants
export const APRECOM_API_LOADING = 'APRECOM_API_LOADING';
export const SAVE_APRECOM_DETAILS = 'SAVE_APRECOM_DETAILS';
export const APRECOM_DETAILS_ERROR = 'APRECOM_DETAILS_ERROR';

export const APRECOM_SITE_LIST_LOADING='APRECOM_SITE_LIST_LOADING';
export const APRECOM_SITE_LIST_DETAILS='APRECOM_SITE_LIST_DETAILS';
export const APRECOM_SITE_LIST_ERROR='APRECOM_SITE_LIST_ERROR';

// router active qoe graph constant
export const ROUTER_ACTIVE_QOE_GRAPH_API_REQUEST = 'ROUTER_ACTIVE_QOE_GRAPH_API_REQUEST';
export const ROUTER_ACTIVE_QOE_GRAPH_API_SUCCESS = 'ROUTER_ACTIVE_QOE_GRAPH_API_SUCCESS';

// NHC - issues summary table
export const ISSUES_SUMMARY_API_REQUEST = 'ISSUES_SUMMARY_API_REQUEST';
export const SAVE_ISSUES_SUMMARY_RESPONSE = 'SAVE_ISSUES_SUMMARY_RESPONSE';
export const USER_NAVIGATE_FROM_NHC = 'USER_NAVIGATE_FROM_NHC';
// client event and stats api const
export const CLIENT_EVENT_AND_STATS_API_LOADING = 'CLIENT_EVENT_AND_STATS_API_LOADING';
export const CLIENT_EVENT_AND_STATS_API_SUCCESS = 'CLIENT_EVENT_AND_STATS_API_SUCCESS';
export const CLIENT_EVENT_AND_STATS_API_ERROR = 'CLIENT_EVENT_AND_STATS_API_ERROR'
